import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";

const BusinessDetailTabsSkeleton = () => {
  const tabs = [
    "Member Data",
    "Invoices & Linked Members",
    "Coaching",
    "Fitness Data & Progress",
    "Membership Plan & Facilities",
  ];

  return (
    <Tabs defaultValue="member-data" className="w-full animate-pulse">
      <Card className="w-full p-4 border-b-0 rounded-none rounded-tl-md rounded-tr-md">
        <TabsList className="border-b rounded-none w-full justify-start h-auto p-0 bg-transparent">
          {tabs.map((tab, index) => (
            <TabsTrigger
              key={index}
              value={tab.toLowerCase().replace(/\s+/g, "-")}
              className="border-b-2 border-transparent data-[state=active]:border-primary rounded-none h-auto pb-2 px-4 text-muted-foreground"
            >
              <div className="h-4 bg-gray-300 rounded w-24"></div>
            </TabsTrigger>
          ))}
        </TabsList>
      </Card>

      <TabsContent value="member-data">
        <Card className="w-full p-4 border-t-0 rounded-none rounded-bl-md rounded-br-md">
          <div className="h-6 bg-gray-300 rounded w-32 mb-4"></div>
          <Card className="p-0">
            <CardContent className="py-5 space-y-3">
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 rounded w-40 mb-2"></div>
                <div className="h-3 bg-gray-300 rounded w-64"></div>
                <Separator className="!mb-3 mt-1" />
              </div>
              <div className="h-3 bg-gray-300 rounded w-full mb-2"></div>
              <div className="h-3 bg-gray-300 rounded w-full mb-2"></div>
              <Separator />
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                <div className="h-3 bg-gray-300 rounded w-64"></div>
              </div>
              <Separator />
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                <div className="h-3 bg-gray-300 rounded w-64"></div>
              </div>
              <Separator />
            </CardContent>
          </Card>
        </Card>
      </TabsContent>
    </Tabs>
  );
};

export default BusinessDetailTabsSkeleton;
